export const DESKTOP_VIDEO =
  'https://cdn.beoble.app/beoble_assets/video/vid.mp4';
export const MOBILE_VIDEO =
  'https://cdn.beoble.app/beoble_assets/video/mobile-vid.mp4';
